import React from 'react'

import { cn } from '~/styled'

import { SkeletonLoader } from './Skeleton'

export const SkeletonHeading = ({
  className
}: {
  className?: React.ComponentProps<typeof SkeletonLoader>['className']
}) => <SkeletonLoader className={cn('w-64', 'h-6', 'rounded-xl', className)} />
